/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import React from 'react';
import ReactDOM from 'react-dom';
import {withRouter} from "react-router";

import { Nav, NavItem, InputGroup, Form, FormGroup, FormControl, ControlLabel, Glyphicon, Label, Button, Panel, ListGroup, ListGroupItem, Grid, Row, Col, Image, Well, Accordion, Badge} from 'react-bootstrap';
import ReactSpinner from 'react-spinjs';
import UserStore from '../../stores/UserStore';
import ProductStore from '../../stores/ProductStore';
import JobStore from '../../stores/JobStore';
import APIActions from '../../actions/apiActions';
import JobOverviewItem from './jobOverviewItem';
import JobDetailEditView from './jobDetailEditView';
import UIHelpers from '../../library/UIHelpers';

class JobOverviewView extends React.Component {
    constructor(props) {
        console.log("[JobsView] - initialisation");

        super(props);
        this.state = {
            jobs : [],
            searchJobs : [],
            products : [],
            loading : false,
            adding : false,
            editing : false,
            editJob : null,
            searchText : "",
            sortType : 1
        };

        this.addNewJob = this.addNewJob.bind(this);
        this._onJobChange = this._onJobChange.bind(this);
        this._onProductChange = this._onProductChange.bind(this);
        this.jobsForProduct = this.jobsForProduct.bind(this);
        this.sortJobs = this.sortJobs.bind(this);

        this.cancelEdit = this.cancelEdit.bind(this);
        this.confirmEdit = this.confirmEdit.bind(this);
        this.search = this.search.bind(this);
        this.refresh = this.refresh.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.jobSearchSetSelection = this.jobSearchSetSelection.bind(this);
    }

    componentDidMount() {
        console.log("[JobOverviewView] - componentDidMount");
        JobStore.addChangeListener(this._onJobChange) ;
        ProductStore.addChangeListener(this._onProductChange) ;
        this.refresh() ;
    }

    componentWillUnmount() {
        console.log("[JobOverviewView] - componentWillUnmount");
        JobStore.removeChangeListener(this._onJobChange);
        ProductStore.removeChangeListener(this._onProductChange);
    }

     _onJobChange() {
         console.log("_onJobChange");
        var s = this.state ;
        s.jobs = JobStore.jobs() ;
        s.loading = false ;
        this.setState(s);
        this.jobSearchSetSelection() ;
        console.log("JOBS=", s.jobs) ;
    }

    _onProductChange() {
        var products = ProductStore.products() ;
        console.log("_onProductChange : LOADED PRODUCTS-", products);
        this.setState({products: products, loading: false});
    }

    jobSearchSetSelection() {
        var s = this.state ;
        var srch = s.searchText || "";
        if (srch === "") {
            s.searchJobs = s.jobs ;
        }
        else {
            let sx = srch.toLowerCase() ;
            console.log("SEARCH SET=", s.jobs);
            s.searchJobs = s.jobs.filter((j) => (j.jobnum && j.jobnum.toLowerCase().includes(sx)) || j.jobId.toLowerCase().includes(sx) || (j.name && j.name.toLowerCase().includes(sx))) ;
        }

        this.setState(s);
    }

    addNewJob(productId) {
        // var s = this.state ;
        // s.adding = true ;
        // s.editJob = null;
        // s.targetProduct = productId;
        // this.setState(s);
        this.props.history.push("/jobs/job?id=new&pid=" + productId);
    }

    jobsForProduct(productId) {
        var r = this.state.searchJobs.filter((j) => j.productId === productId);
        var sorted = this.sortJobs(r,this.state.sortType) ;
        return sorted ;
    }

    cancelEdit() {
        console.log("[JOB] - cancel edit");
        var s = this.state ;
        s.adding = false ;
        s.editing = false ;
        s.editJob = null;
        this.setState(s);
    }

    confirmEdit(job) {
        console.log("JOB-CONFIRM-EDIT:", job);
        var s = this.state ;
        s.adding = false ;
        s.editing = false ;
        s.editJob = job ;

        if (job) {
            for (var ix = 0 ; ix < s.products.length; ix++) {
                var pr = s.products[ix] ;
                if (pr.productId === job.productId) {
                    var r = s.jobs.filter((j) => j.jobId === job.jobId);
                    if (r.length === 0) {
                        // new job
                        s.jobs.push(job) ;
                        break ;
                    }
                    else if (r.length === 1) {
                        // editing
                        // TODO: replace element in jobs array
                        break ;
                    }
                }
            }
        }

        this.setState(s);
    }

    selectJob(job) {
        console.log("JOB : selected=", job);
        this.props.history.push("/jobs/job?id=" + job.jobId + "&pid=" + job.productId);
    }

    search() {
        console.log("SEARCH:::");
        this.jobSearchSetSelection() ;
    }

    refresh() {
        var s = this.state ;
        s.loading = true ;
        this.setState(s);
        let user = UserStore.user();
        if (user) {
            APIActions.searchJobs(this.state.searchText || "*", user.user.username) ;
        }

        APIActions.getAllProducts();
    }

     handleChange(e) {
        e.preventDefault();
        var s = this.state ;
        s.searchText = e.target.value ;
        this.setState(s);
    }

    handleSortSelect(e) {
        if (e === this.state.sortType) {
            return ;
        }

        this.setState({sortType : e});
    }

    sortJobs(jobList,sortType) {
        console.log("SORTING: ", sortType);
        var sorted = jobList;
        switch (sortType) {
            case 1 :
                sorted.sort(function(j1, j2) {
                    if (j1.jobnum && j2.jobnum) {
                        return j1.jobnum.localeCompare(j2.jobnum);
                    }
                    else if (j1.jobnum) {
                        return  -1 ;
                    }
                    else if (j2.jobnum) {
                        return 1 ;
                    }
                    return 0;
                });
                break ;
            case 2 :
                sorted.sort(function(j1, j2) {
                    if (j1.jobnum && j2.jobnum) {
                        return j2.jobnum.localeCompare(j1.jobnum);
                    }
                    else if (j1.jobnum) {
                        return  1 ;
                    }
                    else if (j2.jobnum) {
                        return -1 ;
                    }
                    return 0;
                });
                break ;
            case 3 :
                sorted.sort(function(j1, j2) {
                    if (j1.name && j2.name) {
                        return j1.name.localeCompare(j2.name);
                    }
                    else if (j1.name) {
                        return  -1 ;
                    }
                    else if (j2.name) {
                        return 1 ;
                    }
                    return 0;
                });
                break ;
            default :
                sorted.sort(function(j1, j2) {
                    if (j1.name && j2.name) {
                        return j2.name.localeCompare(j1.name);
                    }
                    else if (j1.name) {
                        return  1 ;
                    }
                    else if (j2.name) {
                        return -1 ;
                    }
                    return 0;
                });
                break ;
        }

        return sorted ;
    }

    resetSearch() {
        this.setState({searchText: ""});
        let user = UserStore.user();
        if (user) {
            APIActions.searchJobs("*", user.user.username) ;
        }
    }

    render() {

         const spinOpts = {
              lines: 13, // The number of lines to draw
              length: 12, // The length of each line
              width: 4, // The line thickness
              radius: 25, // The radius of the inner circle
              scale: 1, // Scales overall size of the spinner
              corners: 1, // Corner roundness (0..1)
              speed: 1, // Rounds per second
              rotate: 0, // The rotation offset
              animation: 'spinner-line-fade-quick', // The CSS animation name for the lines
              direction: 1, // 1: clockwise, -1: counterclockwise
              color: 'blue', // CSS color or array of colors
              fadeColor: 'transparent', // CSS color or array of colors
              top: '40px', // Top position relative to parent
              left: '50%', // Left position relative to parent
              shadow: '0 0 1px transparent', // Box-shadow for the lines
              zIndex: 2000000000, // The z-index (defaults to 2e9)
              className: 'spinner', // The CSS class to assign to the spinner
              position: 'relative', // Element positioning
            };


        var isAdmin = UserStore.isAdministrator();
        var canEdit = UserStore.canEditJobs() ;
        var self = this ;
        return (
            <div>
                <Grid>
                    <Row>
                        <Well className="jobHeader">
                            <h1>Jobs Overview</h1>
                        </Well>
                    </Row>

                    <Row>
                        <Col md={4}>
                            <Form horizontal className="pull-right" onSubmit={event => event.preventDefault()}>
                                <FormGroup controlId="formGroupSearchId">
                                    <InputGroup>
                                        <FormControl type="text" placeholder="enter search text" ref="searchtext" value={this.state.searchText} onChange={this.handleChange}/>
                                        <InputGroup.Button>
                                            <Button onClick={this.search}><Glyphicon glyph="search" /></Button>
                                            <Button bsStyle="success" onClick={this.refresh}><Glyphicon glyph="refresh" /></Button>
                                            <Button bsStyle="success" onClick={this.resetSearch.bind(this)}>Reset Search</Button>
                                        </InputGroup.Button>
                                    </InputGroup>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={1}><b>Sort by</b></Col>
                        <Col md={6}>
                            <Nav bsStyle="pills"  bsSize="xsmall" activeKey={this.state.sortType} onSelect={this.handleSortSelect.bind(this)}>
                                <NavItem eventKey={1} >Job Num {' '}<Glyphicon glyph="arrow-up"/></NavItem>
                                <NavItem eventKey={2} >Job Num {' '}<Glyphicon glyph="arrow-down"/></NavItem>
                                <NavItem eventKey={3} >Job Name {' '}<Glyphicon glyph="arrow-up"/></NavItem>
                                <NavItem eventKey={4} >Job Name {' '}<Glyphicon glyph="arrow-down"/></NavItem>
                            </Nav>
                            <br/>
                        </Col>
                    </Row>

                    <Row hidden={!this.state.loading}>
                         <div className="load-banner">
                            <h3>Please wait... Loading Available Jobs</h3>
                            <ReactSpinner  config={spinOpts}/>
                        </div>
                    </Row>

                    {(this.state.searchJobs.length === 0 && !this.state.loading) &&
                         <Row>
                            <Col>
                                <h3>You have no assigned jobs</h3>
                            </Col>
                         </Row>
                    }

                    <Row>
                        <Col>
                            <Accordion>
                                {this.state.products.map((p) => {
                                    var jp = self.jobsForProduct(p.productId);
                                    if (jp.length === 0 && !isAdmin) {
                                        return "" ;
                                    }

                                    var hdr = (
                                        <div><Badge bsStyle="success" >{jp.length}</Badge>{' '}{' '}{p.name}
                                            {canEdit && <Button className="pull-right" bsSize="xsmall" onClick={this.addNewJob.bind(this,p.productId)}><Glyphicon glyph="plus" /></Button>}
                                        </div>);

                                    // Must be an easier way!!
                                    let numRows = Math.floor(jp.length / 4) + ((jp.length % 4) > 0 ? 1 : 0);
                                    let rows = [];
                                    for (let r = 0 ; r < numRows; r++) {
                                        rows.push(r);
                                    }
                                    return (
                                        <Panel header={hdr} eventKey={p.productId} key={p.productId}>
                                            <div className="container">
                                                {rows.map((row) => {
                                                    let rowData = jp.slice((row * 4), (row * 4) + 4) ;
                                                    return (
                                                            <div className="row" >
                                                                {rowData.map((j) => {
                                                                    return (
                                                                        <Col  key={j.jobId} md={3}  onClick={this.selectJob.bind(this,j)}  >
                                                                            <JobOverviewItem job={j} handler={this.selectedJob}/>
                                                                        </Col>
                                                                    );
                                                                })}
                                                            </div>
                                                        )
                                                    })
                                                }

                                            </div>
                                        </Panel>
                                    );
                                })}
                            </Accordion>
                        </Col>
                    </Row>

                </Grid>
            </div>
        );
    }
}

export default withRouter(JobOverviewView);






// WEBPACK FOOTER //
// ./src/app/components/jobs/jobOverview.js